import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaVideo,
  FaChevronDown,
  FaImage,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "../../css/User/CreateRevolution.css";
import { revolutionApi } from "../../api/revolutionApi";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVideo,
  faLocationDot,
  faImage,
  faLink,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
import RevolutionEmail from "../../components/model/RevolutionEmail";
import { getSidebarMenus } from "../../constants/sidebarMenus";
import { Icon } from "@iconify/react";
import TopHeader from "../../components/comman/TopHeader";
import Sidebar from "../../components/comman/Sidebar";
import { FaLink } from "react-icons/fa6";
import { getCurrentUserId } from "../../utils/auth";
import { useProfile } from "../../hook/useProfile";

function CreateRevolution() {
  const { isProfileInfo } = useProfile();
  const isRevolutionPermission = isProfileInfo?.revolutionPermission;
  const currentUserId = getCurrentUserId();
  const [open, setOpen] = useState(false);
  const [visibility, setVisibility] = useState("Select Visibility");
  const [toText, setToText] = useState("");
  const [subjectText, setSubjectText] = useState("");
  const [messageText, setMessageText] = useState("");
  const [feedType, setFeedType] = useState("prime");
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [activeSidebar, setActiveSidebar] = useState("revolution-create");
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);
  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const toInputRef = useRef(null);
  const subjectInputRef = useRef(null);
  const messageInputRef = useRef(null);
  const [postText, setPostText] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [videoType, setVideoType] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const imageRef = useRef(null);
  const videoRef = useRef(null);
  const sidebarMenus = getSidebarMenus(currentUserId);
  const ALLOWED_VISIBILITY = ["STATE", "DISTRICT", "NATIONAL"];
  const MAX_IMAGES = 10;
  const MAX_VIDEOS = 2;
  const MAX_FILES = 5;
  const [showPopup, setShowPopup] = useState(false);

  // Handle Visibility Select

  const handleSelect = (value) => {
    setVisibility(value);
    setOpen(false);
  };

  // REVOLUTION SUBMITION

  const RevolutionSubmit = async () => {
    if (!isRevolutionPermission) {
      setShowPopup(true);
      return;
    }

   

   if(!ALLOWED_VISIBILITY.includes(visibility) ||
      toText === "" ||
      subjectText === "" ||
      messageText === ""
  ){
      toast.error("All fields are required.");
      return;
    }

    const formData = new FormData();

    formData.append("to", toText);
    formData.append("title", subjectText);
    formData.append("description", messageText);
    formData.append("visibility", visibility);

    selectedImages.forEach((img) => {
      formData.append("images", img.file);
    });

    selectedVideo.forEach((video) => {
      formData.append("videos", video.file);
    });

    selectedFiles.forEach((file) => {
      formData.append("pdfs", file);
    });

    try {
      setIsUploading(true);

      const data = await revolutionApi.createRevolution(formData);
      toast.success("Revolution created successfully");
      resetPostForm();
      navigate("/revolution/my");
    } catch (err) {
      console.error(err);
      toast.error("Upload failed You must verify your adhaar first");
    } finally {
      setIsUploading(false);
    }
  };

  // for video selection

  const handleVideoSelect = (e) => {
    const files = Array.from(e.target.files);

    if (selectedVideo.length + files.length > MAX_VIDEOS) {
      // alert(`You can upload maximum ${MAX_VIDEOS} videos`);
      toast.error(`You can upload maximum ${MAX_VIDEOS} videos`);
      e.target.value = "";
      return;
    }

    const videoPromises = files.map((file) => {
      return new Promise((resolve) => {
        const video = document.createElement("video");
        video.preload = "metadata";

        video.onloadedmetadata = () => {
          resolve({
            file,
            preview: URL.createObjectURL(file),
            duration: video.duration,
            type: video.duration <= 60 ? "short" : "long",
          });
        };

        video.src = URL.createObjectURL(file);
      });
    });

    Promise.all(videoPromises).then((videos) => {
      setSelectedVideo((prev) => [...prev, ...videos]);
    });
  };

  // for image selection

  const handleImageSelect = (e) => {
    const files = Array.from(e.target.files);

    if (selectedImages.length + files.length > MAX_IMAGES) {
      //   alert(`You can upload maximum ${MAX_IMAGES} images`);
      toast.error(`You can upload maximum ${MAX_IMAGES} images`);
      e.target.value = "";
      return;
    }

    const imageFiles = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setSelectedImages((prev) => [...prev, ...imageFiles]);
  };

  // for removing selected video

  const removeVideo = (index) => {
    setSelectedVideo((prev) => prev.filter((_, i) => i !== index));

    // reset input so same video can be selected again
    if (videoInputRef.current) {
      videoInputRef.current.value = "";
    }
  };

  // for removing selected image

  const removeImage = (index) => {
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));

    // reset input so same image can be selected again
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
  };

  // Create Post Form Reset Function

  const resetPostForm = () => {
    setPostText("");
    setSelectedImages([]);
    setSelectedVideo([]);
    setSelectedFiles([]);
    setVideoType("");
    setVisibility("Select Visibility");
    setToText("");
    setSubjectText("");
    setMessageText("");

    imageInputRef.current && (imageInputRef.current.value = "");
    videoInputRef.current && (videoInputRef.current.value = "");
    fileInputRef.current && (fileInputRef.current.value = "");

    toInputRef.current && (toInputRef.current.value = "");
    subjectInputRef.current && (subjectInputRef.current.value = "");
    messageInputRef.current && (messageInputRef.current.value = "");
  };

  // Handle File Selection

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);

    if (selectedFiles.length + files.length > MAX_FILES) {
      //   alert(`You can upload maximum ${MAX_FILES} files`);
      toast.error(`You can upload maximum ${MAX_FILES} files`);

      e.target.value = "";
      return;
    }

    setSelectedFiles((prev) => [...prev, ...files]);
  };

  // Remove File

  const removeFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // Close popup when clicking outside

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfile(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [showRevolutionCard, setShowRevolutionCard] = useState(false);
  const goToProfile = () => {
    navigate("/profile");
  };

  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        {/* <div className="page-container"> */}

        {/* ================= TOP HEADER NAVBAR ================= */}

        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />

        {/* ================= PRIME PUBLIC LAYOUT CONTAINER ================= */}
        <div className="prime-layout-container .container-fluid">
          <div className="row">
            {!showSidebar && (
              <div
                className="left-sidebar-overlay d-md-none"
                onClick={() => setShowSidebar(true)}
              />
            )}

            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              feedType={feedType}
              onNavigate={(item) => {
                setActiveSidebar(item.key);
                if (item.path) {
                  navigate(item.path);
                }
              }}
            />
            {/* LEFT SIDEBAR END */}

            <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
              <div className="center-area">
                <div className="w-100 pb-5">
                  <div className="rev-wrapper py-4">
                    <div className="rev-card">
                      {/* Header */}
                      <div className="rev-header">
                        <h2>Revolution</h2>
                        <p>Explore The Truth To The World</p>
                      </div>

                      {/* Post Visibility */}

                      <div className="visibility-wrapper">
                        <button
                          className="visibility-btn"
                          onClick={() => setOpen((prev) => !prev)}
                        >
                          <span>{visibility}</span>
                          <FaChevronDown
                            className={`dropdown-icon ${open ? "open" : ""}`}
                          />
                        </button>
                        {open && (
                          <div className="visibility-dropdown">
                            <div onClick={() => handleSelect("NATIONAL")}>
                              National
                            </div>
                            <div onClick={() => handleSelect("STATE")}>
                              State
                            </div>
                            <div onClick={() => handleSelect("DISTRICT")}>
                              District
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Form */}
                      <div className="rev-form">
                        <input
                          ref={toInputRef}
                          name="revolutionTo"
                          type="text"
                          placeholder="To"
                          onChange={(e) => setToText(e.target.value)}
                        />
                        <input
                          ref={subjectInputRef}
                          name="revolutonSubject"
                          type="text"
                          placeholder="Subject"
                          onChange={(e) => setSubjectText(e.target.value)}
                        />
                        <textarea
                          ref={messageInputRef}
                          name="revolutionMessage"
                          rows="4"
                          placeholder="Message......"
                          onChange={(e) => setMessageText(e.target.value)}
                        ></textarea>
                      </div>

                      <div className="rev-footer">
                        <div className="w-100">
                          {selectedImages.length > 0 && (
                            <div className="image-preview-box mt-2">
                              {selectedImages.map((img, index) => (
                                <div
                                  className="preview-image-wrapper"
                                  key={index}
                                >
                                  <img
                                    src={img.preview}
                                    className="preview-image"
                                  />
                                  <span
                                    className="remove-img"
                                    onClick={() => removeImage(index)}
                                  >
                                    ×
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}

                          {/* VIDEO PREVIEW */}
                          {selectedVideo.length > 0 && (
                            <div className="video-preview-box mt-2">
                              {selectedVideo.map((video, index) => (
                                <div
                                  className="preview-video-wrapper"
                                  key={index}
                                >
                                  <video
                                    src={video.preview}
                                    controls
                                    className="video-preview"
                                  />

                                  <span className="video-type-label">
                                    {video.type === "short"
                                      ? "🎬 Short Video"
                                      : "🎥 Long Video"}
                                  </span>

                                  <span
                                    className="remove-video"
                                    onClick={() => removeVideo(index)}
                                  >
                                    ×
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}

                          {/* FILE PREVIEW */}
                          {selectedFiles.length > 0 && (
                            <div className="file-preview-box mt-2">
                              {selectedFiles.map((file, index) => (
                                <div key={index} className="file-preview-item">
                                  <FontAwesomeIcon icon={faFile} />
                                  <span className="file-name">{file.name}</span>

                                  <span
                                    className="remove-file text-danger"
                                    onClick={() => removeFile(index)}
                                  >
                                    ×
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}

                          <div className="create-footer mt-2">
                            <div className="create-icons">
                              {/* IMAGE ICON */}
                              <label className="">
                                <FontAwesomeIcon icon={faImage} />
                                <input
                                  ref={imageInputRef}
                                  type="file"
                                  accept="image/*"
                                  multiple
                                  hidden
                                  onChange={handleImageSelect}
                                />
                              </label>

                              <label className="">
                                <FontAwesomeIcon icon={faVideo} />
                                <input
                                  ref={videoInputRef}
                                  type="file"
                                  accept="video/*"
                                  multiple
                                  hidden
                                  onChange={handleVideoSelect}
                                />
                              </label>

                              <label>
                                <FontAwesomeIcon icon={faLink} />
                                <input
                                  ref={fileInputRef}
                                  type="file"
                                  accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                                  multiple
                                  hidden
                                  onChange={handleFileSelect}
                                />
                              </label>

                              {/* <label className="">
                                <FontAwesomeIcon icon={faLocationDot} />
                              </label> */}
                            </div>

                            <button
                              className="share-post-btn"
                              onClick={() =>
                                RevolutionSubmit({ postFeedType: "PRIME" })
                              }
                              disabled={isUploading}
                            >
                              {isUploading ? "Posting..." : "Submit"}
                            </button>

                            {!isRevolutionPermission && showPopup && (
                              <RevolutionEmail
                                popupMSG="If you want to create revolution, you need approval from the admin. You can contact the admin at the email address below."
                                onClose={() => {
                                  setShowPopup(false);
                                  navigate("/feeda/prime");
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
    // </>
  );
}
export default CreateRevolution;
